import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { setNavBarProps } from 'store/navbar'
import { modalActions } from 'store/modal'
import {
  USER_ROLES_MAP,
  USER_ROLE_IDS_CAN_SEE_FLAGSMITH_CONFIGURATION,
  USER_ROLE_IDS_CAN_EDIT_STUDY_VERSION_DETAILS,
} from 'utils/constants'
import { getUserScope, getUserScopeByStudy, getUserRoleByStudy, getUserRoleId, isRootOrDchAdmin } from 'utils/misc'
import CreateStudyConfigurationPage from '../components/CreateStudyConfigurationPage'
import { actions as studyActions } from '../modules/CreateStudy'
import { actions as notyActions } from '../../../../../layouts/ErrorBox'

const mapState = (state, ownProps) => {
  const { user, study, location, loading, studyLock } = state
  const path = location.pathname.match(/([^/]+$)/)[0]
  const { params } = ownProps
  const { studyVersionID } = params
  const userRole = params && params.studyID ? getUserRoleByStudy(user, params.studyID) : ''
  const { id } = study?.currentStudy
  const isFlagsmithConfigurationSectionShown = USER_ROLE_IDS_CAN_SEE_FLAGSMITH_CONFIGURATION.includes(
    getUserRoleId(user, id),
  )

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const hasAccessToEditVersionNotes = USER_ROLE_IDS_CAN_EDIT_STUDY_VERSION_DETAILS.includes(getUserRoleId(user, id))
  const currentStudy = study?.currentStudy
  const canEditStudyConfiguration =
    !!currentStudy?.id &&
    getUserScopeByStudy(user, currentStudy).includes('wu') &&
    !studyLock

  return {
    disabled: !ownProps.isWizard && !location.pathname.includes('create'),
    hasDeleteStudyPermissions: getUserScope(user).includes('wu') && userRole === USER_ROLES_MAP.root,
    isRootOrDchAdmin: isRootOrDchAdmin(user),
    saveAttempted: study.saveAttempted,
    study: study.currentStudy,
    studyVersionList: study.studyVersionList,
    loading,
    locales: study.locales,
    preview: path === 'preview',
    selectedTab: path,
    isFlagsmithConfigurationSectionShown,
    hasAccessToEditVersionNotes,
    hasStudyPromotion,
    userId: user?.id,
    studyVersionID,
    canEditStudyConfiguration,
    studyLock,
  }
}

const mapDispatch = { ...modalActions, ...studyActions, ...notyActions, setNavBarProps }

export default connect(
  mapState,
  mapDispatch,
)(props => {
  return props.loading.general ? <Loader active /> : <CreateStudyConfigurationPage {...props} />
})
